import React, { useState, useEffect } from 'react';
import { AdminDashboardAPI } from '../../Services/ECommerceAPI';
import { toast } from 'react-toastify';
import './ECommerceDashboard.css';

const ECommerceDashboard = () => {
    const [stats, setStats] = useState(null);
    const [recentOrders, setRecentOrders] = useState([]);
    const [topProducts, setTopProducts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadDashboardData();
    }, []);

    const loadDashboardData = async () => {
        try {
            setLoading(true);
            const [statsData, ordersData, productsData] = await Promise.all([
                AdminDashboardAPI.getStats(),
                AdminDashboardAPI.getRecentOrders(5),
                AdminDashboardAPI.getTopProducts(5)
            ]);
            setStats(statsData);
            setRecentOrders(ordersData);
            setTopProducts(productsData);
        } catch (error) {
            console.error('Error loading dashboard:', error);
            toast.error('Failed to load dashboard data');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <div className="dashboard-loading">Loading dashboard...</div>;
    }

    return (
        <div className="ecommerce-dashboard">
            <h1>E-Commerce Dashboard</h1>
            
            {stats && (
                <div className="stats-grid">
                    <div className="stat-card">
                        <h3>Total Orders</h3>
                        <p className="stat-value">{stats.totalOrders}</p>
                    </div>
                    <div className="stat-card">
                        <h3>Total Revenue</h3>
                        <p className="stat-value">${stats.totalRevenue.toFixed(2)}</p>
                    </div>
                    <div className="stat-card">
                        <h3>Pending Orders</h3>
                        <p className="stat-value">{stats.pendingOrders}</p>
                    </div>
                    <div className="stat-card">
                        <h3>Total Products</h3>
                        <p className="stat-value">{stats.totalProducts}</p>
                    </div>
                    <div className="stat-card">
                        <h3>Published Products</h3>
                        <p className="stat-value">{stats.publishedProducts}</p>
                    </div>
                    <div className="stat-card">
                        <h3>Low Stock</h3>
                        <p className="stat-value warning">{stats.lowStockProducts}</p>
                    </div>
                </div>
            )}

            <div className="dashboard-content">
                <div className="dashboard-section">
                    <h2>Recent Orders</h2>
                    <div className="orders-table">
                        <table>
                            <thead>
                                <tr>
                                    <th>Order Number</th>
                                    <th>Customer</th>
                                    <th>Total</th>
                                    <th>Status</th>
                                    <th>Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {recentOrders.map(order => (
                                    <tr key={order.orderID}>
                                        <td>{order.orderNumber}</td>
                                        <td>{order.customer?.firstName} {order.customer?.lastName}</td>
                                        <td>${order.totalAmount.toFixed(2)}</td>
                                        <td>
                                            <span className={`status-badge ${order.orderStatus?.statusName?.toLowerCase()}`}>
                                                {order.orderStatus?.statusName}
                                            </span>
                                        </td>
                                        <td>{new Date(order.orderDate).toLocaleDateString()}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="dashboard-section">
                    <h2>Top Products</h2>
                    <div className="top-products">
                        {topProducts.map((product, index) => (
                            <div key={product.productID} className="top-product-item">
                                <span className="rank">#{index + 1}</span>
                                <span className="product-name">{product.productName}</span>
                                <span className="product-stats">
                                    <span>Qty: {product.totalQuantity}</span>
                                    <span>Revenue: ${product.totalRevenue.toFixed(2)}</span>
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ECommerceDashboard;
